import { useBatchDownload } from 'components/AssetsCardGroup/hooks/useBatchDownload';
import { SimpleAsset } from 'queries/assets/contract';

interface AssetCoverProps {
  asset: SimpleAsset;
}

export function AssetCover({ asset }: AssetCoverProps) {
  const { getImageForAsset } = useBatchDownload([
    {
      id: asset.id,
      name: asset.name,
    },
  ]);

  const img = getImageForAsset(asset.id);

  return (
    <div className="pdf-cover-wrapper">
      <img src={img?.resolvedSrc} alt={asset?.name} className="pdf-cover-img" />
    </div>
  );
}
